import { Countries } from "@features/seo/seo.constants";
import { City } from "@shared/lib/interfaces/city.interface";

export const PLATFORMS = [
    { value: 0, label: "Likvi.com", country: Countries.RU },
    { value: 1, label: "Drom.ru", country: Countries.RU },
    { value: 2, label: "Avito.ru", country: Countries.RU },
    { value: 3, label: "Auto.ru", country: Countries.RU },
    { value: 6, label: "Aster.kz", country: Countries.KZ },
    { value: 7, label: "Mycar.kz", country: Countries.KZ },
    { value: 8, label: "Kolesa.kz", country: Countries.KZ },
    { value: 9, label: "Mobile.de", country: Countries.DE },
    { value: 10, label: "Av.by", country: Countries.BY },
    { value: 12, label: "Migtorg.com", country: Countries.RU }
];

export const getCountries = () => {
    const uniqueCountries = new Set(PLATFORMS.map((platform) => platform.country));
    return Array.from(uniqueCountries).map((country) => {
        return {
            value: country,
            label: getCountryNameByCode(country)
        };
    });
};

export const getCountryNameByCode = (code: Countries) => {
    switch (code) {
        case Countries.RU:
            return "Россия";
        case Countries.KZ:
            return "Казахстан";
        case Countries.BY:
            return "Беларусь";
        case Countries.DE:
            return "Германия";
        default:
            return "Россия";
    }
};

export const SourceToCountry: { [key: number]: Countries } = {
    1: Countries.RU,
    2: Countries.RU,
    3: Countries.RU,
    4: Countries.RU,
    5: Countries.RU,
    6: Countries.KZ,
    7: Countries.KZ,
    8: Countries.KZ,
    9: Countries.DE,
    10: Countries.BY,
    11: Countries.RU,
    12: Countries.RU
};

export const OWNERS_QNT = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" }
];

export const TIMER_DURATION = 60;

export const enum Sort {
    Popular = "Популярные",
    Expensive = "Сначала дорогие",
    Cheap = "Сначала дешевые",
    YearNewer = "По году: Новее",
    YearOlder = "По году: Старше",
    MileageLess = "По пробегу: Меньше",
    MileageMore = "По пробегу: Больше",
    ByName = "По названию"
}

export const enum TimeSort {
    Hour = "За час",
    ThreeHours = "За 3 часа",
    Day = "За день",
    Week = "За неделю",
    Month = "За месяц",
    AllTime = "За все время"
}
export const TimeSlots = [
    { value: "За час", label: "За час" },
    { value: "За 3 часа", label: "За 3 часа" },
    { value: "За день", label: "За день" },
    { value: "За неделю", label: "За неделю" },
    { value: "За месяц", label: "За месяц" },
    { value: "За все время", label: "За все время" }
];

export const DefaultTimeSort = {
    created_at: {
        order: "asc"
    }
};

export interface FilterParams {
    brandValue?: string;
    modelValue?: string;
    generationValue?: string;
    yearFromValue?: number;
    yearToValue?: number;
    engineVolumeFromValue?: number;
    engineVolumeToValue?: number;
    bodyValue?: string;
    transmissionValue?: string;
    engineTypeValue?: string;
    driveValue?: string;
    wheelValue?: string;
    priceFromValue?: number;
    priceToValue?: number;
    mileageFromValue?: number;
    mileageToValue?: number;
    horsePowerFromValue?: number;
    horsePowerToValue?: number;
    ownerQntFrom?: number;
    ownersQntTo?: number;
    citiesValue?: City[];
    sourceId?: number[];
    timeFrom?: string;
    sellerType?: string;
    sort?: string;
    created_at?: string | null;
    cityAlias?: string;
    brandAlias?: string;
    modelAlias?: string;
    generationCode?: number;
    restyling?: number;
    country?: string;
    hideNoImages?: boolean;
}

export const AnalyticsFiltersList = [
    "mark",
    "model",
    "year",
    "generation_number",
    "displacement",
    "prep_body_type",
    "prep_engine_type",
    "prep_drive_type",
    "prep_transmission"
];

export const MAIN_PAGE_ADBLOCK_POSITIONS = [4, 11, 15];
export const CATALOG_PAGE_ADBLOCK_POSITIONS = [4, 11, 21];
export const DEFAULT_PAGE_LIMIT = 45;
export const PAGE_LIMIT_MAIN_SCREEN = 24;
export const PAGE_LIMIT_BLOG_SLUG_PAGE = 3;
export * from "./utils";